import { styled } from '@mui/material/styles';

export const LogoBox = styled('div')(({ theme }) => ({
  flexShrink: 0,
}));
